export default __webpack_public_path__ + "images/8281bdcf69afb6ed52aeb2cbc4c2c91c.svg";